module.exports = __webpack_public_path__ + "img/ia-01-9.2c644cfd.jpg";